import { assertUnreachable, TranslatableText } from '@dreryk/react-common';

import { useVideoConsultationGlobalState } from '../shared/useVideoConsultationGlobalState';

import { VideoConsultationStartButton } from './VideoConsultationStartButton';
import { VideoConsultationWindowShowButton } from './VideoConsultationWindowShowButton';

type VideoConsultationButtonProps = Readonly<{
   appointmentId: number;
   label: TranslatableText;
}>;

export const VideoConsultationButton = (props: VideoConsultationButtonProps): JSX.Element | null => {
   const { state } = useVideoConsultationGlobalState();

   switch (state.type) {
      case 'idle':
         return <VideoConsultationStartButton appointmentId={props.appointmentId} label={props.label} />;
      case 'inCall': {
         if (state.originId === props.appointmentId) {
            return state.window.minimized ? <VideoConsultationWindowShowButton /> : null;
         }

         return <VideoConsultationStartButton appointmentId={props.appointmentId} label={props.label} disabled />;
      }
      default:
         return assertUnreachable(state);
   }
};
